import Units from "../../../utils/Units";

let gridColor = "rgba(0, 0, 0, 0.1)";
let tickFontSize = 10;
let Kpa = {
    id: "kpa",
    gridLines: {
        color: gridColor,
        zeroLineColor: "rgba(0, 0, 0, 0)"
    },
    ticks: {
        fontSize: tickFontSize,
        maxTicksLimit: 10,

        callback: (value, index, values) => {
            return "  " + Units.rounded(value,2) + " kPa";
        }
    }
};

export default Kpa;



// WEBPACK FOOTER //
// ./src/components/chart/axes/Kpa.js